import { useRef, useState } from "react";
import { toPng } from "html-to-image";
import { toast } from "sonner";
import { Certificate, DownloadSimple } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

// Digital certificate for a verified/completed alumni contribution to a project.
export default function ImpactCertificate({ contribution, projectTitle, institutionName }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const badge = contribution?.badge || {};
  const download = async () => {
    if (!ref.current) return;
    try {
      const dataUrl = await toPng(ref.current, { cacheBust: true, pixelRatio: 2, skipFonts: true });
      const a = document.createElement("a");
      a.download = `AlumniPulse-Certificate-${(projectTitle || "impact").replace(/\s+/g, "-")}.png`;
      a.href = dataUrl; a.click();
      toast.success("Certificate downloaded");
    } catch { toast.error("Could not generate the certificate"); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1.5" data-testid="view-certificate-btn"><Certificate size={16} weight="duotone" /> Your certificate</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-xl" data-testid="certificate-dialog">
        <DialogHeader><DialogTitle>Your AlumniPulse Impact Certificate</DialogTitle></DialogHeader>
        <div ref={ref} className="relative overflow-hidden rounded-xl border-4 border-double border-secondary/40 bg-gradient-to-br from-green-50 via-white to-orange-50 p-8 text-center">
          <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-secondary">AlumniPulse™ · Certificate of Impact</div>
          <div className="mt-5 text-sm text-muted-foreground">This certifies that</div>
          <div className="mt-1 font-heading text-3xl font-medium text-foreground">{contribution?.anonymous ? "An Anonymous Alumni Supporter" : (contribution?.user_name || "Alumni Supporter")}</div>
          <div className="mt-4 text-sm text-muted-foreground">contributed as a</div>
          <div className="mt-1 text-xl font-medium text-secondary">{badge.icon} {contribution?.help_label}</div>
          <div className="mt-4 text-sm text-muted-foreground">in support of</div>
          <div className="mt-1 text-lg font-medium">{projectTitle}</div>
          <div className="text-sm text-muted-foreground">{institutionName}</div>
          <div className="mt-6 text-xs italic text-muted-foreground">"Your alma mater remembers what you gave back."</div>
          <div className="mt-4 text-[11px] text-muted-foreground">{(contribution?.verified_at || "").slice(0, 10)}</div>
        </div>
        <Button onClick={download} className="w-full gap-1.5" data-testid="download-certificate-btn"><DownloadSimple size={16} /> Download PNG</Button>
      </DialogContent>
    </Dialog>
  );
}
